import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TYPE_MENU } from 'app/core/models/constans.model';
import { Menu } from 'app/menu/models/menu.model';
import { Restaurant } from 'app/menu/models/restaurants.model';
import { MenuStorageService } from 'app/menu/services/menu-storage.service';
import { MenuService } from 'app/menu/services/menu.service';

@Component({
    selector: 'app-menu-selectors',
    templateUrl: './menu-selectors.component.html',
    styleUrls: ['./menu-selectors.component.scss'],
    standalone: false
})
export class MenuSelectorsComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Informacion del restaurante actual
   */
  restaurant: Restaurant = {} as Restaurant;
  /**
   * Idioma seleccionado
   */
  language = 'ES';
  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private menuService: MenuService,
    private menuStorage: MenuStorageService

  ) { }

  ngOnInit(): void {
    this.menuService.getLang().subscribe((lan: string) => {
      this.language = lan;
    });
    this.menuStorage.restaurant$.subscribe((restaurant: Restaurant) => {
      this.restaurant = restaurant;
    });
  }


  /**
   * Navega al menu indicado
   *
   * @param type tipo de menu
   */
  goMenu(type: string): void {
    this.router.navigateByUrl(`menu-detail/${this.activateRoute.snapshot.params.id}/${type}`);
  }


  /**
   * Valida si tiene o no el menu indicado
   *
   * @param type tipo de menu
   * @returns boolean
   */
  hasMenu(type: string): boolean {
    switch (type) {
      case 'cocina':
      case 'bar':
        return this.restaurant.menuType === TYPE_MENU.twoMenu
          || this.restaurant.menuType === TYPE_MENU.threeMenu || this.restaurant.menuType === TYPE_MENU.fourMenu ? true : false;
      case 'brunch':
        return (this.restaurant.menuType === TYPE_MENU.threeMenu || this.restaurant.menuType === TYPE_MENU.fourMenu)
          && !this.restaurant.brunchOff ? true : false;
      case 'extra':
        return (this.restaurant.menuType === TYPE_MENU.fourMenu)
          && this.restaurant.imgExtra ? true : false;
      default:
        return this.restaurant.menuType === (TYPE_MENU.twoMenu || TYPE_MENU.threeMenu) ? true : false;
    }
  }

  /**
   * Indica si es el menu actual
   *
   * @param type tipo de menu
   */
  isCurrentMenu(type: string): boolean {
    return this.activateRoute.snapshot.params.type === type;
  }


  /**
   * Determina el tipo de columna dependiendo
   * el tipo de menu del restaurante
   *
   * @returns
   */
  getColumnClass(): string {
    switch (this.restaurant.menuType) {
      case TYPE_MENU.twoMenu:
        return 'col-12 text-center';
      case TYPE_MENU.oneMenu:
        return 'd-none';
      case TYPE_MENU.threeMenu:
        return 'col-5';
      default:
        return '';
    }
  }

  /**
   * Get the font for the menu sections
   *
   * @returns
   */
  getFont(): string {
    if (this.menu.fontSections && this.menu.fontSections !== '') {
      return this.menu.fontSections;
    }
    return this.menu.fontHeader;
  }

}
